import { useTranslation } from 'react-i18next'

import { Divider } from '@reveni-io/reveni-ui'

import { getRefundMethodFieldId } from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/helpers'

import ExtraAmountSelector from '../ExtraAmountSelector/ExtraAmountSelector'
import ExtraCreditAccumulationToggle from '../ExtraCreditAccumulationToggle/ExtraCreditAccumulationToggle'
import InputAndSelect from '../InputAndSelect/InputAndSelect'
import { giftCardDurationTypes } from './constants'
import * as Styles from './styles'

const GiftCardConfiguration = ({
  extraValueType,
  handleExtraValueType,
  extraValue,
  handleExtraValue,
  maxExtraAmount,
  handleMaxExtraAmount,
  minEligibleRefundAmount,
  handleMinEligibleRefundAmount,
  storeCurrencySymbol,
  errors,
  refundMethodName,
  duration,
  onChangeInputDuration,
  onChangeSelectDuration,
  onChangeToggleExpirationSelect,
  allowExtraWhenPaidWithCredit,
  handleAllowExtraWhenPaidWithCredit,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <InputAndSelect
        label={t('Validez')}
        menuItems={[
          { label: t('Años'), value: giftCardDurationTypes.years },
          { label: t('Meses'), value: giftCardDurationTypes.months },
          { label: t('Días'), value: giftCardDurationTypes.days },
        ]}
        inputValue={duration?.number}
        inputOnChange={onChangeInputDuration}
        inputError={Boolean(errors?.duration)}
        inputFieldId={getRefundMethodFieldId(refundMethodName, 'duration')}
        selectValue={duration?.type}
        selectOnChange={onChangeSelectDuration}
        showToggleExpirationSelect={true}
        onChangeToggleExpirationSelect={onChangeToggleExpirationSelect}
        disabled={disabled}
      />
      <Divider />
      <ExtraAmountSelector
        value={extraValueType}
        onChange={handleExtraValueType}
        extraValue={extraValue}
        handleExtraValue={handleExtraValue}
        maxExtraAmount={maxExtraAmount}
        handleMaxExtraAmount={handleMaxExtraAmount}
        minEligibleRefundAmount={minEligibleRefundAmount}
        handleMinEligibleRefundAmount={handleMinEligibleRefundAmount}
        storeCurrencySymbol={storeCurrencySymbol}
        disabled={disabled}
        errors={errors}
        refundMethodName={refundMethodName}
      />
      <ExtraCreditAccumulationToggle
        checked={allowExtraWhenPaidWithCredit}
        onChange={handleAllowExtraWhenPaidWithCredit}
        disabled={disabled}
        label={t('Añadir crédito adicional aunque el pedido haya sido pagado con una tarjeta regalo.')}
      />
    </Styles.Container>
  )
}

export default GiftCardConfiguration
